/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_FADE_FLY_OUT_RIGHT = 'fadeFlyOutRight';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const fadeFlyOutRightPresetDetails = {
  // The name of the preset.
  name: PRESET_FADE_FLY_OUT_RIGHT,

  // A human friendly name for the preset.
  humanName: 'Fade Out & Fly Out Right',

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    opacity: {
      time: {
        end: 'end.0',
        start: 'end.-600'
      },
      easing: EASINGS.easeInOutPower2,
      values: [
        1,
        0
      ],
      immediateRender: false
    },
    'position.x': {
      time: {
        end: 'end.0',
        start: 'end.-600'
      },
      easing: EASINGS.easeInOutPower2,
      values: [
        0,
        500
      ],
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_FADE_FLY_OUT_RIGHT,
    options: {},
  },
};

fadeFlyOutRightPresetDetails.template.options = lodash.cloneDeep(fadeFlyOutRightPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_FADE_FLY_OUT_RIGHT;

// This defines the value of the presets object.
export default fadeFlyOutRightPresetDetails;
